module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_04-d369d32f0e4182f1fbde1cbbf3a87a9b.jpg";